import { render, staticRenderFns } from "./ShiftTypeDialog.vue?vue&type=template&id=02248bc6"
import script from "./ShiftTypeDialog.vue?vue&type=script&lang=ts"
export * from "./ShiftTypeDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports